export function capitalizeEveryWord(word) {
    if (!word) return '';
    
    return word
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
